import { findIndex } from "lodash"

export default function pushPopPhotoCard(array, item) {
  if(findIndex(array, (i) => i.photoCardId === item.photoCardId) >= 0) {
    return array.filter((t) => t?.photoCardId !== item.photoCardId)
  } else {
    array.push(item)
    return array
  }
}